const shortcuts = {
  close: 'esc',
  addFiles: 'ctrl+o,cmd+o',
  importJSON: 'ctrl+i,cmd+i',
  exportJSON: 'ctrl+e,cmd+e',
  closeFile: 'alt+q',
  saveFile: 'ctrl+s,cmd+s',
  undo: 'ctrl+z,cmd+z',
  redo: 'ctrl+shift+z,cmd+shift+z',
};

export default shortcuts;
